__turbopack_context__.v({
  "container": "AnimatedExamplesBox-module-scss-module__g-fr5q__container",
  "example": "AnimatedExamplesBox-module-scss-module__g-fr5q__example",
});
